module.exports = __webpack_public_path__ + "static/img/CT_3.e3b04391.png";